<template>
    <div class="template">
      <Header
        class="template__header"
      />

      <div class="template__content">
        <RouterView/>
      </div>
    </div>
</template>

<script>
import Header from '@/components/layout/TheHeader.vue';

export default {
  components: {
    Header,
  },
};
</script>
